import $ from 'jquery';
class formUiJS {
    constructor() {
        //this.events();
        this.formUi();
        this.getYourLegislatorForm();
    }

    getYourLegislatorForm() {
        //$( "#new_answer" ).submit(function( e ) {  
        $("#find_your_legislator").on('submit', function(e){
             return true;
            // if($("#street_address").val()!="" || $("#city").val()!='' || $("#zipcode").val()!="")
            //     //$(this).submit()
            //     return true;
            // else{
            //     $("#alertInfo").removeClass("d-none");
            //     e.preventDefault();
            //     return false;
            // }

        });
    }

    formUi() {
        //console.log('imhrere');
        $(document).on('can_embed_loaded', function () {
            //var ajax = new XMLHttpRequest();

            //$('#log-out').trigger( "click" );

            // do your work here, after the widget is loaded
            $('input[name="answer[first_name]"]').parents('.core_field').addClass('wrapping');
            $('input[name="answer[last_name]"]').parents('.core_field').addClass('wrapping');
            $('.wrapping').wrapAll('<div class="first_last_name"></div>');
            $('.js-d_sharing input[type=checkbox] + input').each(function () {
                $(this.nextSibling).wrap('<span></span>');
            });
            $('.control-group textarea')
                .on('focus blur', function (e) {
                    $(this)
                        .parents('.control-group')
                        .toggleClass('is-focused', e.type === 'focus' || this.value.length > 0);
                })
                .trigger('blur');
            $('.form-wrapper form input[type=submit]').wrap('<div class="submit-btn-wrapper"></div>');
            var submitValue = $('.form-wrapper form input[type=submit]').val();
            $('.form-wrapper form input[type=submit]').after('<span>'+submitValue+'</span>');

            const frmSelector = document.querySelector('#new_answer');

            frmSelector.addEventListener('submit', function(e){
                e.preventDefault();
                if($("#isDeaForm").val()=='yes' && $("#DEA-Public-Comment").val()!=""){
                    
                    var sendData = {
                        'firstname' : $("#form-first_name").val(),
                        'lastname' : $("#form-last_name").val(),
                        'email' : $("#form-email").val(),
                        'city' : $("#form-city").val(),
                        'zipcode' : $("#form-zip_code").val(),
                        'sendEmailReceipt': true,
                        'publiccomments' : $("#DEA-Public-Comment").val(),
                        'action': 'comment_on_document',
                    }
                    //console.log(sendData);
                    $.ajax(   
                                {
                                    type: "POST",
                                    url: dwd_object.ajaxurl, 
                                    data: sendData,
                                    success: function(result) {
                                        //console.log("Successfull: "+result);
                                        console.log("Successfull");
                                    },
                            });
                    return false;
                }
                //frmSelector.submit();
            });
        });
    }

    events() {
        
    }
}
new formUiJS();